import { gql } from '@apollo/client';
import { EventsAndTimeslots } from 'types/Event';
import {EVENT_FRAGMENT, TIMESLOT_FRAGMENT} from './EventFragments';

export const GET_EVENTS_QUERY = gql`
  query GetEvents($getEventsInput: GetEventsInput!) {
    getEvents(getEventsInput: $getEventsInput) {
      __typename

      ... on GetEventsErrorOutput {
        errorReason
      }

      ... on GetEventsOutput {
        filteredEvents {
          __typename

          ... on Event {
            ...eventFields
          }

          ... on Timeslot {
            ...timeslotFields
          }
        }
      }
    }
  }
  ${EVENT_FRAGMENT}
  ${TIMESLOT_FRAGMENT}
`;

export enum GetEventsError {
  NOT_LINKED = 'NOT_LINKED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  WRONG_LINK = 'WRONG_LINK',
}

export type GetEventsOutput = {
  getEvents: {
    errorReason?: GetEventsError;
    filteredEvents?: EventsAndTimeslots;
  };
};
